import { cn } from '@/lib/cn'
import { normalizeWebsite, websiteLabel } from '@/lib/website'
import type { GameInfo } from '@/models/game-info'

/** A link to a game's own site, when whoever added the game gave one. */
export function GameWebsiteLink({
  game,
  className,
}: {
  game: GameInfo | null | undefined
  className?: string
}) {
  // Checked again here so an address saved before validation can't render as
  // a non-web link.
  const href = game?.website ? normalizeWebsite(game.website) : null
  if (!href) return null

  return (
    <a
      className={cn('game-website-link', className)}
      href={href}
      target="_blank"
      rel="noopener noreferrer nofollow ugc"
      onClick={(event) => event.stopPropagation()}
    >
      <svg viewBox="0 0 16 16" aria-hidden="true">
        <path d="M6.5 3.5H3.5v9h9v-3M9 3h4v4M13 3 7.5 8.5" />
      </svg>
      <span>{websiteLabel(href)}</span>
      <span className="sr-only"> (game website, opens in a new tab)</span>
    </a>
  )
}
